const cache_lifetime = 5; // minutes

export const jobs = 'job';

export class TariffRoute {
    constructor() {
        this.tabs = this.getTabs();
    }

    async getTabs() {
        let now = +new Date();
        let timeX = sessionStorage.getItem('cl_timeout');

        let tabs = sessionStorage.getItem('cl_tabs');
        if (tabs && timeX > now) {
            tabs = JSON.parse(tabs)
            return tabs;
        }
        let response = await fetch('/api/tariffs/tabs/');
        tabs = await response.json();
        sessionStorage.setItem('cl_tabs', JSON.stringify(tabs))
        let time = new Date();
        let timeout = time.setMinutes(time.getMinutes() + cache_lifetime);
        sessionStorage.setItem('cl_timeout', timeout)
        return tabs;
    }

    async tab(name) {
        let tabs = await this.tabs;
        let tab = tabs.filter(tab => tab.group === name);
        if (typeof tab !== 'undefined' && tab.length > 0) {
            return tab[0].tab_name || '';
        }
    }
}
